import shieldImage from "../../../assets/images/PlanForParents.png";
import { ReactComponent as ShieldIcon } from "../../../assets/icons/ShieldIcon.svg";
import { HashLink } from "react-router-hash-link";
import SecondaryButton from "../../designSystem/SecondaryButton";
import { useLocation } from "react-router-dom";

const PlanForParents = () => {
    const location = useLocation();
    const isSchoolPage = location.pathname === "/for-schools";
  return (
    <section
      // className="plan"
      // style={{ backgroundImage: `url(${BlueBgImage})` }}
      className=" plan section-bg section-bg--blue"
    >
      <div className="plan__container">
        {/* LEFT CONTENT */}
        <div className="plan__content">
          <h4>PLAN FOR PARENTS</h4>
          <div className="divider" />
          <div className="content-medium">
            Your child's education could be at risk, which is why we:
          </div>

          <ul className="plan__list">
            <li className="body">
              <ShieldIcon /> Provide insurance designed specifically for
              independent school fees
            </li>
            <li className="body">
              <ShieldIcon /> Help ensure education continues despite life’s
              most difficult events
            </li>
            <li className="body">
              <ShieldIcon /> Give specialist advice focused on protecting your
              child’s education
            </li>
          </ul>
        <HashLink
          smooth
          to={isSchoolPage ? "/for-schools#contact" : "/#contact"}
          style={{ textDecoration: "none" }}
        >
          <SecondaryButton>
            <div className="button-text primary">SIGN UP NOW</div>
          </SecondaryButton>
        </HashLink>
        </div>

        {/* RIGHT IMAGE */}
        <div className="plan__image-wrap">
          <img src={shieldImage} alt="Family planning" />
        </div>
      </div>
    </section>
  );
};

export default PlanForParents;
